import { CustomersFacade } from '@domain/application/facade';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { ParametersService } from '@modules/business-accounts/services/parameters/parameters.service';
import { dateRangeValidator, setMaxDatePicker } from '@utils/functions/datepicker';
import { IStep } from '../../utils/interfaces/step.interface';
import { tap } from 'rxjs';
import { CustomerReniecResponse } from '@utils/interfaces/response';
import { LegalRepresentService } from '@domain/application/observable-services/legal-representative.service';
import { Unsubscriber } from '@utils/mixins/unsubscribe.mixin';
import { formatPhoneNumber } from '@modules/business-accounts/utils/classes/string';
import { SessionService } from '@domain/application/observable-services/session.service';
import { TraceService } from '@modules/business-accounts/services/trace/trace.service';
import { VisitEvent } from '@modules/business-accounts/utils/classes/visit-event.class';
import { TraceEventName } from '@modules/business-accounts/utils/enums/trace-events.enum';

@Component({
  selector: 'ba-legal-representative-step',
  templateUrl: './legal-representative-step.component.html',
  styleUrls: ['./legal-representative-step.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class LegalRepresentativeStepComponent extends Unsubscriber() implements OnInit, IStep<void> {
  @Input() usePersonalDataForm: boolean = true;
  @Input() legalRepresentantNumber!: string;
  @Input() ruc!: string;
  @Input() isClient = false;
  @Input() isLegalRepresentativeClient = false;
  @Output() stepDone = new EventEmitter<void>();

  ibkConfig = setMaxDatePicker(18);
  addressForm = (this.controlContainer.control as FormGroup).get('address') as FormGroup;

  customer$!: ReturnType<CustomersFacade['fetchLegalRepresentative']>;

  constructor(
    public readonly controlContainer: ControlContainer,
    public readonly paramsService: ParametersService,
    private readonly customersFacade: CustomersFacade,
    private legalRepresentantService: LegalRepresentService,
    private readonly sessionService: SessionService,
    private readonly traceService: TraceService
  ) {
    super();
  }

  ngOnInit(): void {
    if (!this.legalRepresentantService.legalRepresentantValue) {
      this.customer$ = this.customersFacade.fetchReniecData(this.legalRepresentantNumber).pipe(
        tap(({ customer }: CustomerReniecResponse) => {
          this.legalRepresentantService.setLegalRepresentant = customer;
          // if (customer.gender) {
          //   this.form.get('gender')?.setValue(customer.gender);
          // }
          // if (customer.maritalStatus) {
          //   this.form.get('maritalStatus')?.setValue(customer.maritalStatus);
          // }
          const mobilePhone = customer.phone?.find((phone) => phone.type === 'MOBILE');
          if (mobilePhone) {
            this.form.get('phoneNumber')?.setValue(formatPhoneNumber(mobilePhone.number));
          }
          if (customer.email && customer.email.length > 0) {
            this.form.get('email')?.setValue(customer.email[0].value);
          }
        })
      );
    }

    if (this.form.get('isSameAddress')?.value) {
      this.form.get('address')?.disable();
      this.form.get('address')?.reset();
    }

    this.form.get('isSameAddress')?.valueChanges.subscribe((val) => {
      if (val) {
        this.form.get('address')?.disable();
        this.form.get('address')?.reset();
      } else {
        this.form.get('address')?.enable();
      }
    });
  }

  get form() {
    return (this.controlContainer as FormGroupDirective).form;
  }

  done() {
    this.traceService.registerEvent(new VisitEvent(TraceEventName.ACTION_LEGAL_PERSONAL_DATA));
    if (!this.isLegalRepresentativeClient) this.sessionService.setCommonInfo = { email: this.form.get('email')?.value };
    this.stepDone.emit();
  }

  chkPep(event: any) {
    const isChecked = event.target.checked;
    const partner = this.form as FormGroup;
    if (isChecked) {
      partner.addControl(
        'pepLegalRepresentative',
        new FormGroup({
          pepEntity: new FormControl(null),
          pepPosition: new FormControl(null),
          pepStartDate: new FormControl(null),
          pepEndDate: new FormControl(null),
        },
          [Validators.required, dateRangeValidator])
      );
    } else {
      partner.removeControl('pepLegalRepresentative');
    }
  }
}
